import type CountryCode from '@alltrails/core/types/CountryCode';
import { post } from '@alltrails/shared/api';
import type ProResponse from '../types/ProResponse';

type Subscription = {
  app_source?: string;
  apple_pay_token?: string;
  appsflyer_id?: string;
  billing_country: CountryCode;
  cc_token?: string;
  google_pay_token?: string;
  multiyear_conversion?: boolean;
  os_version?: string;
  paypal_token?: string;
  price_code: string;
  recaptcha: string;
  uid: number;
  user: {
    billing_first_name?: string;
    billing_last_name?: string;
    zip?: string;
    user_entered_coupon_code?: string;
  };
};

// see app/controllers/api/alltrails/default/purchases/subscriptions_controller.rb
export default async function createSubscription(body: Subscription) {
  return post<ProResponse>('/api/alltrails/purchases/subscriptions', body);
}
